import { helpDescriptionModel } from '@/stores/cvc';
import { parameterSelector, parametersValueModel } from '@/stores/models';
import { useCallback } from 'react';
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from 'recoil';

import { CheckboxParameter, ParameterType, SliderParameter } from './config';
import { SliderControl } from './SliderControl';
import SwitchControl from './SwitchControl';

const Parameters = () => {
  const parameters = useRecoilValue(parameterSelector);
  const setDescription = useSetRecoilState(helpDescriptionModel);
  const resetDescription = useResetRecoilState(helpDescriptionModel);
  const [parametersValue, setParametersValue] =
    useRecoilState(parametersValueModel);
  const onChangeParameters = useCallback(
    (value: { [key: string]: number | boolean }) => {
      setParametersValue((pre) => {
        return {
          ...pre,
          ...value,
        };
      });
    },
    [setParametersValue]
  );

  // Check if absolute mode is enabled for age/gender parameters
  const isAbsoluteMode = parametersValue['gender_age_mode'] === true;

  return (
    <section className="model-parameters">
      {parameters?.map((parameter, index) => {
        // Skip age_shift and gender_shift in absolute mode
        if (
          isAbsoluteMode &&
          (parameter.name === 'age_shift' || parameter.name === 'gender_shift')
        ) {
          return null;
        }

        // Skip age_trg and gender_trg in relative mode
        if (
          !isAbsoluteMode &&
          (parameter.name === 'age_trg' || parameter.name === 'gender_trg')
        ) {
          return null;
        }

        return (
          <section
            key={parameter.name}
            className="model-parameter"
            onMouseEnter={() => setDescription({ main: parameter.tooltip })}
            onMouseLeave={() => resetDescription()}
          >
            {parameter.type === ParameterType.Checkbox ? (
              <SwitchControl
                value={
                  (parametersValue[parameter.name] ??
                    parameter.defaultValue) as boolean
                }
                key={parameter.name}
                parameter={parameter as CheckboxParameter}
                onChange={onChangeParameters}
              />
            ) : (
              <SliderControl
                key={`${parameter.name}_${index}`}
                value={
                  (parametersValue[parameter.name] ??
                    parameter.defaultValue) as number
                }
                parameter={parameter as SliderParameter}
                onChange={onChangeParameters}
              />
            )}
          </section>
        );
      })}
    </section>
  );
};

export default Parameters;
